// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iiBy","colBig":"styles_colBig__1aESB","colSmall":"styles_colSmall__35vdx","shopifyNameWrapper":"styles_shopifyNameWrapper__3VWJN"};